import ACTIONS from "../actions/actionTypes"

export const currentPath = (state = "", action) => {
  if (action.type === ACTIONS.GET_CURRENT_PATH) return action.path
  return state
}
